import { combineReducers } from "redux";

import appReducer from "components/feature/app/reducer";
import authReducer from "components/feature/auth/reducer";
import betbarParentReducer from "components/feature/betbar/reducer";
import drawerReducer from "components/feature/drawer/reducer";
import translationsReducer from "components/feature/translations/reducer";

export default combineReducers({
  app: appReducer,
  auth: authReducer,
  betbarParent: betbarParentReducer,
  drawer: drawerReducer,
  translations: translationsReducer,
});
